import { Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const BuyLicensesCards = () =>
{
	const navigate = useNavigate();

	return (
		<div className='flexCol respdngSM'>
			<div className='flexRow pdngXS'>
				<span className='mainHdngTxt'> Pricing Details</span>
			</div>
			<div className='flexWrap'>
				<div className='resoneThirdWidth pdngXS '>
					<div className='flexCol textCntr alignCntr justifyCntr whiteBg pdngLG brdrRadiusSM'>
						<h5 className='primaryTxt mainHdngTxtMD mrgnTMD'>FREE</h5>
						<p className='lightTxt mrgnBLG'>5 connections</p>
						<h1 className='CardTxt mrgnBLG'>₹0</h1>
						<span className='lightTxt pdngBXS'>14 days free trial</span>
						<span className='lightTxt pdngBLG'>No credit card required. </span>
						<div className='mrgnVSM'>
							<Button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && navigate('/place-your-order'); }} variant='contained' disableElevation disableRipple disableTouchRipple className='whiteTxt' onClick={() => { navigate('/place-your-order'); }}>Start Trail</Button>
						</div>
					</div>
				</div>
				<div className='resoneThirdWidth pdngXS '>
					<div className='flexCol textCntr alignCntr justifyCntr whiteBg pdngLG brdrRadiusSM'>
						<h5 className='primaryTxt mainHdngTxtMD mrgnTMD'>STANDARD</h5>
						<p className='lightTxt mrgnBLG'>50 connections</p>
						<h1 className='CardTxt mrgnBLG'>₹500</h1>
						<span className='lightTxt pdngBXS'>14 days free trial</span>
						<span className='lightTxt pdngBLG'>Credit card required. </span>
						<div className='mrgnVSM'>
							<Button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && navigate('/place-your-order'); }} variant='contained' disableElevation disableRipple disableTouchRipple className='whiteTxt' onClick={() => { navigate('/place-your-order'); }}>Buy Now</Button>
						</div>
					</div>
				</div>
				<div className='resoneThirdWidth pdngXS '>
					<div className='flexCol textCntr alignCntr justifyCntr whiteBg pdngLG brdrRadiusSM'>
						<h5 className='primaryTxt mainHdngTxtMD mrgnTMD'>PRO</h5>
						<p className='lightTxt mrgnBLG'>100 connections</p>
						<h1 className='CardTxt mrgnBLG'>₹1000</h1>
						<span className='lightTxt pdngBXS'>14 days free trial</span>
						<span className='lightTxt pdngBLG'>Credit card required. </span>
						<div className='mrgnVSM'>
							<Button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && navigate('/place-your-order'); }} variant='contained' disableElevation disableRipple disableTouchRipple className='whiteTxt' onClick={() => { navigate('/place-your-order'); }}>Buy Now</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BuyLicensesCards;